import { AvatarGroup, Stack, type StackProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import type { FC } from "react";

const PREFIX = "PrescriptionTableRow";

export const classes = {
  root: `${PREFIX}-root`,
  header: `${PREFIX}-header`,
  cell: `${PREFIX}-cell`,
  status: `${PREFIX}-status`,
  candidate: `${PREFIX}-candidate`,
  phone: `${PREFIX}-phone`,
  place: `${PREFIX}-place`,
  accompaniement: `${PREFIX}-accompaniement`,
  author: `${PREFIX}-author`,
  prescriptionDate: `${PREFIX}-prescriptionDate`,
  action: `${PREFIX}-action`,
  avatarGroup: `${PREFIX}-avatarGroup`,
};

interface IPrescriptionTableRowProps extends StackProps {
  hasVisualizeCandidatePermission?: boolean;
}

export const PrescriptionTableRow = styled<FC<IPrescriptionTableRowProps>>(Stack, {
  shouldForwardProp: (prop) => prop !== "hasVisualizeCandidatePermission",
})(({ theme, hasVisualizeCandidatePermission }) => ({
  [`& .${classes.root}`]: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    [`&.${classes.header}`]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(1),
    },
    [`&:not(.${classes.header}):hover`]: {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
      boxShadow: "-4px 0 0 0 rgba(0, 0, 0, 0.04), 4px 0 0 0 rgba(0, 0, 0, 0.04)",
    },
    [`& .${classes.cell}`]: {
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      marginLeft: "12px",
      marginRight: "12px",
    },
    [`& .${classes.cell}:first-child`]: {
      marginLeft: "0px",
    },
    [`& .${classes.cell}:last-child`]: {
      marginRight: "0px",
    },
    [`& .${classes.candidate}`]: {
      flex: "0 0 20%",
      overflow: "hidden",
      textOverflow: "ellipsis",
      cursor: hasVisualizeCandidatePermission ? "pointer" : "unset",
      [theme.breakpoints.up("desktop")]: {
        flex: "0 0 15%",
      },
    },
    [`& .${classes.phone}`]: {
      [theme.breakpoints.up("desktop")]: {
        flex: "0 0 10%",
      },
      flex: "0 0 17%",
    },
    [`& .${classes.place}`]: {
      [theme.breakpoints.up("desktop")]: {
        flex: "0 0 7%",
      },
    },
    [`& .${classes.status}`]: {
      [theme.breakpoints.up("desktop")]: {
        flex: "0 0 9%",
      },
      overflow: "hidden",
      flex: "0 0 15%",
    },
    [`& .${classes.accompaniement}`]: {
      flex: "0 0 15%",
      overflow: "hidden",
    },
    [`& .${classes.author}`]: {
      flex: "0 0 5%",
      overflow: "hidden",
    },
    [`& .${classes.prescriptionDate}`]: {
      [theme.breakpoints.up("desktop")]: {
        flex: "0 0 9%",
      },
      overflow: "hidden",
      flex: "0 0 15%",
    },
    [`& .${classes.action}`]: {
      overflow: "hidden",
      flex: "0 0 10%",
    },
  },
}));

export const UserChipStyled = styled(AvatarGroup)(({ theme }) => ({
  [`&.${classes.avatarGroup}`]: {
    gap: theme.spacing(1),
    justifyContent: "start",
    "& .MuiAvatarGroup-avatar": {
      ...theme.typography.body1,
      backgroundColor: theme.palette.primary.main,
      width: theme.spacing(3),
      height: theme.spacing(3),
      margin: 0,
      border: 0,
    },
  },
}));
